import {Box, styled, Modal, Subtitle1, Body1} from '../../../ui-library';

export const ModalContainer = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;
`;
export const ModalBox = styled(Box)`
    display: inline-flex;
    padding: 30px 34px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    background: #FFF;
    width: 210px;
    height: 206px;
`;

export const Title = styled(Subtitle1)`
    ${({ theme }) => theme.typography.subtitle1};
    font-weight: 700;
    margin-top: 11px;
    margin-bottom: 11px;
`;

export const SubTitle = styled(Body1)`
    font-weight: 400;
`;
